import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PicklistService } from "../../services/administration/picklist/picklist.service";
import { IPicklistFieldsData } from "../../interfaces/administration/picklistFieldsData";

@Component({
  selector: "app-add-field",
  templateUrl: "./add-field.component.html",
  styles: [
    `
      .button-container {
        display: flex !important;
        justify-content: space-between !important;
        margin: 10px 0px 0px 0px;
      }
    `,
  ],
})
export class AddFieldComponent {
  @Output() fieldCreated = new EventEmitter<{
    fieldName: string;
    parentId: string | null;
  }>();
  @Output() formClosed = new EventEmitter<void>();

  @Input() picklists: IPicklistFieldsData[] = [];

  form: FormGroup;
  validationMessages: string[] = [];
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private picklistService: PicklistService
  ) {
    this.form = this.fb.group({
      fieldName: ["", Validators.required],
      parentPicklist: [0],
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.validationMessages.push("Field name is required.");
      return;
    }
    this.isLoading = true;
    this.validationMessages = [];
    if (this.form.valid) {
      this.fieldCreated.emit({
        fieldName: this.form.value.fieldName,
        parentId: this.form.value.parentPicklist,
      });
      this.form.reset();
    }
  }

  cancel() {
    this.form.reset();
    this.formClosed.emit();
  }
}
